<template>
  <b-card :class="$route.path.includes('dashboard') ? 'h-100' : ''">
    <b-card-header class="p-0 pb-1">
      <b-card-title>
        <h4>آخرین نظرات</h4>
      </b-card-title>
    </b-card-header>
    <div
      class="d-flex px-0 flex-wrap align-items-center"
      v-if="$route.path.includes('dashboard')"
    >
      <b-form-group
        label="فیلتر بر اساس"
        class="mb-1 col-12 col-sm-4 pr-md-2 pr-sm-50 px-0"
      >
        <select-box
          v-model="regarding_type"
          label="text"
          class="w-100"
          select="val"
          :lists="types"
          searchable
        />
      </b-form-group>
      <b-form-group
        v-if="regarding_type"
        class="mb-1 col-12 col-sm-8 pr-md-2 px-0"
        label="انتخاب شناسه"
      >
        <select-box
          v-model="regarding_id"
          label="text"
          class="w-100"
          select="id"
          :url="regarding_type"
          searchable
        />
      </b-form-group>
    </div>
    <data-table :fields="fields" :items="comments" :loading="loading">
      <template #id="{ data }">
        {{ data.item.id }}
      </template>
      <template #user="{ data }">
        <span style="white-space: nowrap">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </span>
      </template>
      <template #regarding="{ data }">
        <div style="white-space: nowrap">
          {{ data.item.regarding.name }}
        </div>
      </template>
      <!-- <template #comment_at="{ data }">
        <b-badge variant="light-secondary">
          {{ calcDate(data.item.comment_at) }}
        </b-badge>
      </template> -->

      <template #status="{ data }">
        <b-badge :variant="data.item.status ? 'light-success' : 'light-danger'"
          >{{ data.item.status ? "فعال" : "غیر فعال" }}
        </b-badge></template
      >
      <template #actions="{ data }">
        <div class="d-flex justify-content-around">
          <b-button
            @click="showAnswerModal(data.item)"
            size="sm"
            variant="flat-primary"
            class="d-flex"
          >
            <feather-icon icon="TwitchIcon" />
            <div class="ml-50 text-truncate" style="width: 300px">
              {{ data.item.content }}
            </div>
          </b-button>

          <!-- <b-button
            size="sm"
            :variant="data.item.active ? 'flat-success' : 'flat-danger'"
          >
            <feather-icon :icon="data.item.active ? 'CheckIcon' : 'XIcon'" />
            <span class="ml-50">{{
              !data.item.active ? "تغییر به فعال" : " تغییر به غیر فعال"
            }}</span>
          </b-button> -->

          <b-button
            size="sm"
            variant="flat-danger"
            class="d-flex align-items-center"
            @click="removeComment(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
    </data-table>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      v-model="visibleRes"
      hide-footer
      centered
      noCloseOnBackdrop
    >
      <validation-observer ref="addUserForm" #default="{ invalid }">
        <b-form class="auth-add-user-form my-2" @submit.prevent="sendComment">
          <div v-if="editMode">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="comment"
                vid="comment"
                rules="required"
              >
                <b-form-textarea
                  rows="4"
                  v-model="comment.content"
                  :state="errors.length > 0 ? false : null"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div
            class="p-1 d-flex align-items-center justify-content-between"
            v-else
          >
            <div class="text-justify">
              {{ comment.content }}
            </div>
            <b-button
              variant="flat-secondary"
              size="sm"
              @click="editMode = true"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>

          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="content"
              vid="content"
              rules="required"
            >
              <b-form-textarea
                rows="4"
                v-model="content"
                :state="errors.length > 0 ? false : null"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-button
            variant="primary"
            block
            type="submit"
            class="my-1"
            :disabled="invalid"
          >
            ثبت پاسخ
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <!-- <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div> -->
      <div
        class="col-md-12 d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="mt-2 mb-0 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <!-- <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form> -->
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormTextarea,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormInput,
  BCardHeader,
  BCardTitle,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BCard,
    BLink,
    BAvatar,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BFormInput,
    SelectBox,
    BCardHeader,
    BCardTitle,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      editMode: false,
      types: [
        {
          id: 1,
          text: "دوره",
          val: "course",
        },
        {
          id: 2,
          text: "ترم",
          val: "semester",
        },
      ],
      choosenPage: 1,
      comments: [],
      loading: false,
      removeCommentsData: [],
      required,
      visible: false,
      visibleRes: false,
      content: "",
      search: "",
      selectAll: [],
      pagination: {},
      currentPage: 1,
      comment: {},
      fields: [
        { key: "user", label: "کاربر" },
        { key: "regarding", label: "نظر مرتبط به" },
        // { key: "comment_at", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
        // { key: "actions", label: "عملیات" },
      ],

      regarding_type: "",
      regarding_id: "",
    };
  },

  watch: {
    currentPage(val) {
      this.getComments(val);
    },
    regarding_type(val) {
      this.regarding_id = "";
    },
    regarding_id(val) {
      if (this.regarding_type == null) {
        this.getComments();
      }
      if (this.regarding_type && val) {
        this.getComments();
      }
    },
  },
  created() {
    this.getComments();
  },
  methods: {
    showAnswerModal(comment) {
      this.comment = comment;
      this.content =
        comment.children &&
        comment.children.data &&
        comment.children.data.length
          ? comment.children.data[0].content
          : "";
      this.editMode = false;
      this.visibleRes = true;
    },
    async sendComment() {
      this.loading = true;

      try {
        if (this.editMode) {
          await this.$http.put(`/panel/comments/${this.comment.id}`, {
            content: this.comment.content,
            status: this.comment.status,
          });
        }
        const { data } = await this.$http.post("/panel/comments", {
          regarding: {
            type: this.comment.regarding_type,
            id: this.comment.regarding_id,
          },
          parent_id: this.comment.id,
          content: this.content,
        });
        await this.getComments();
        this.visibleRes = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "جواب با موفقیت ثبت شد",
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "مشکلی پیش آمده است",
            icon: "EditIcon",
            variant: "warning",
          },
        });
      }
      this.loading = false;
    },

    async getComments(page) {
      this.loading = true;
      try {
        let filters = {};
        if (this.$route.path.includes("dashboard")) {
          this.regarding_type &&
            this.regarding_id &&
            (filters.regarding = {
              type: this.regarding_type,
              id: this.regarding_id,
            });
        } else if (this.$route.path.includes("semesters")) {
          filters.regarding = {
            type: "semester",
            id: this.$route.params.id,
          };
        } else if (this.$route.path.includes("users")) {
          filters = {
            user_id: this.$route.params.id,
          };
        }

        const { data } = await this.$http.get("/panel/comments", {
          params: {
            includes: ["user", "comment", "children", "regarding"],
            per_page: 8,
            page: page || 1,
            filters: {
              ...filters,
            },
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.comments = data.data.comments;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style>
tr {
  height: 50px !important;
}
</style>
